(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bbwarm-landing"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-bb-image]').forEach(button=>button.addEventListener('click',()=>{const image=document.getElementById('bb-main-image');if(!image)return;image.src=button.dataset.bbImage;image.removeAttribute('srcset');image.alt=button.dataset.bbAlt;document.querySelectorAll('[data-bb-image]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)))}));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
